import { render, staticRenderFns } from "./ReservationsAll.vue?vue&type=template&id=178a818a&"
import script from "./ReservationsAll.vue?vue&type=script&lang=js&"
export * from "./ReservationsAll.vue?vue&type=script&lang=js&"
import style0 from "./ReservationsAll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports